"use client";
import { useState } from "react";
import {
  FaFacebookF,
  FaXTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaPrint,
  FaStar,
} from "react-icons/fa6";
import { Tooltip } from "flowbite-react";

const ShareRating = () => {
  const [rating, setRating] = useState(0);

  const socialLinks = [
    {
      id: "facebook",
      icon: <FaFacebookF size={14} />,
      url: "https://facebook.com/sharer/sharer.php?u=",
      color: "bg-blue-600 hover:bg-blue-700 text-white",
    },
    {
      id: "twitter",
      icon: <FaXTwitter size={14} />,
      url: "https://twitter.com/intent/tweet?url=",
      color: "bg-black hover:bg-gray-900 text-white",
    },
    {
      id: "linkedin",
      icon: <FaLinkedinIn size={14} />,
      url: "https://www.linkedin.com/shareArticle?url=",
      color: "bg-blue-700 hover:bg-blue-800 text-white",
    },
    {
      id: "email",
      icon: <FaEnvelope size={14} />,
      url: "mailto:?subject=Regarde ceci!&body=",
      color: "bg-gray-500 hover:bg-gray-600 text-white",
    },
    {
      id: "print",
      icon: <FaPrint size={14} />,
      action: () => window.print(),
      color: "bg-gray-400 hover:bg-gray-500 text-white",
    },
  ];

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <div className="flex flex-col items-center justify-between border-t border-gray-300 p-4 sm:flex-row">
      {/* Partage Social */}
      <div className="flex items-center space-x-3">
        <span className="font-semibold text-gray-700">Partager:</span>
        <div className="flex space-x-2">
          {socialLinks.map(({ id, icon, url, action, color }) => (
            <Tooltip
              key={id}
              content={id.charAt(0).toUpperCase() + id.slice(1)}
            >
              {action ? (
                <button
                  onClick={action}
                  className={`flex h-10 w-10 items-center justify-center rounded-full ${color} shadow-md transition-all duration-300 hover:shadow-lg`}
                >
                  {icon}
                </button>
              ) : (
                <a
                  href={`${url}${encodeURIComponent(currentUrl)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex h-10 w-10 items-center justify-center rounded-full ${color} shadow-md transition-all duration-300 hover:shadow-lg`}
                >
                  {icon}
                </a>
              )}
            </Tooltip>
          ))}
        </div>
      </div>

      {/* Notation */}
      <div className="mt-3 flex items-center space-x-2 sm:mt-0">
        <span className="font-semibold text-gray-700">Noter:</span>
        <div className="flex space-x-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => setRating(star)}
              className={`flex h-10 w-10 items-center justify-center rounded-full transition ${
                star <= rating
                  ? "bg-yellow-400 text-white"
                  : "bg-gray-300 text-gray-500 hover:bg-gray-500 hover:text-white"
              }`}
            >
              <FaStar size={16} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShareRating;
